<div>
  @if (title()) {
    <h3 class="text-lg font-semibold mb-2">{{ title() }}</h3>
  }
  @if (badge()) {
    <span class="chart-badge">{{ badge() }}</span>
  }
  <div class="relative" [class]="heightClass()">
    @if (loading()) {
      <div class="absolute inset-0 flex items-center justify-center">
        <xemex-spinner size="md" />
      </div>
    }
    @if (unit()) {
      <span class="absolute left-0 top-0 z-10 text-xs font-medium text-gray-400">{{ unit() }}</span>
    }
    <canvas
      [hidden]="loading()"
      [class.pointer-events-none]="loading()"
      baseChart
      [data]="chartData()"
      [options]="chartOptions()"
      [type]="chartType()"
      class="h-full w-full"
    ></canvas>
  </div>
  @if (note()) {
    <p class="chart-note">{{ note() }}</p>
  }
</div>
